import React from "react";
import styled from "styled-components";

export const PerformanceColumnHeading = styled.div`
    text-transform: none;
    font-size: 11px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
`;

export const PerformanceCell = styled.div`
    display: flex;
    justify-content: flex-end;
    font-size: 12px;
`;
